/* This is the Root component mainly initializes Redux and React Router. */

import React from 'react';
import { Provider } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { hot, setConfig } from 'react-hot-loader';
import store from './common/store';
import routeConfig from './common/routeConfig';
import history from './common/history';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ApolloProvider } from '@apollo/client';
import apolloClient from './common/apollo';
import {themeConfig} from './common/themes/config';
import * as PDFJS from 'pdfjs-dist';
// defaultTheme
import themes from './common/themes';

setConfig({
  logLevel: 'debug',
});

PDFJS.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@2.1.266/build/pdf.worker.min.js';

function renderRouteConfigV3(routes, contextPath) {
  // Resolve route config object in React Router v3.
  const children = []; // children component list

  const renderRoute = (item, routeContextPath) => {
    let newContextPath;

    if (/^\//.test(item.path)) {
      newContextPath = item.path;
    } else {
      newContextPath = `${routeContextPath}/${item.path}`;
    }

    newContextPath = newContextPath.replace(/\/+/g, '/');

    if (item.component && item.childRoutes) {
      const childRoutes = renderRouteConfigV3(item.childRoutes, newContextPath);

      children.push(
        <Route
          key={newContextPath}
          render={props => <item.component {...props}>{childRoutes}</item.component>}
          path={newContextPath}
        />,
      );
    } else if (item.component) {
      // children.push(
      //   <Route key={newContextPath} component={item.component} path={newContextPath} exact />,
      // );
      children.push(
          <Route key={newContextPath}
                 render={props => {
                   const compProps = {...props, ...item.props};
                   return (
                       <item.component {...compProps} />
                   );
                 }}
                 path={newContextPath}
                 exact />,
      );
    } else if (item.childRoutes) {
      item.childRoutes.forEach(r => renderRoute(r, newContextPath));
    }
  };

  routes.forEach(item => renderRoute(item, contextPath));

  // Use Switch so that only the first matched route is rendered.
  return <Switch>{children}</Switch>;
}

function Root() {
  const children = renderRouteConfigV3(routeConfig, '/');
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(themeConfig)}>
        <CssBaseline />
        <ApolloProvider client={apolloClient}>
          <Provider store={store}>
            <ConnectedRouter history={history}>{children}</ConnectedRouter>
          </Provider>
        </ApolloProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default hot(module)(Root);
